import { curry } from 'ramda';

/**
 * Checks if a string contains a value.
 *
 * @param {string} value needle
 * @param {string} item haystack
 * @returns {Boolean} does contain
 */
const contains = curry((value, item) => item.indexOf(value) !== -1);

export default contains;
